
import VideoPlayer from '@/components/VideoPlayer/videojs.vue'
export default {
  props: {
    modal: {
      default: false,
      type: Boolean,
    },
    item: {
      default: () => {},
    },
    videoPath: {
      default: '',
    },
  },
  data() {
    return {
      showYoutube: '',
      videoOptions: {
        live: false,
        autoplay: this.modal,
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        sources: [
          {
            src: this.videoPath,
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  methods: {
    SET_SOURCE() {
      if (this.item.videoPath.includes('www.youtube.com/watch?v=')) {
        this.showYoutube = this.item.videoPath.split(
          'www.youtube.com/watch?v='
        )[1]
      }
    },
  },
  components: { VideoPlayer },
  mounted() {
    this.SET_SOURCE()
  },
}
